import { Box, Divider } from "@mui/material";
import { usePDF } from "@react-pdf/renderer";
import { AxiosError, AxiosResponse } from "axios";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import Card from "src/components/common/Card";
import Checkbox from "src/components/common/FormComponents/Checkbox";

import MapComponent from "src/components/common/KML";
import StatusHistory from "src/components/common/StatusHistory";
import ViewForm from "src/components/common/ViewForm";
import ViewImages from "src/components/common/ViewImage";
import { ProjectType, PROJECT_DOCUMENT_TYPE_MAP } from "src/constants/common";
import { CustomStyles, getStyles } from "src/styles/theme";
import {
  addProjectToIo,
  getIOdDetails,
  getMyProfileData,
  getProjectById,
} from "src/utils/api/dashboard";
import {
  dateAndTimeStamp,
  downloadS3File,
  downloadSheet,
  getFormattedDate,
} from "src/utils/helper";
import defaultStyles, { StylesClasses } from "../styles";
import TreePdf from "./TreePdf";
import { Button } from "src/components/common/FormComponents/Buttons";
import AutoComplete from "src/components/common/FormComponents/AutoComplete";
import { useAppSelector } from "src/redux/store";
import ProjectDetailSkeleton from "src/components/common/ProjectDetailSkeleton";

type TreeProjectProps = {
  projectId: string;
  customStyles?: CustomStyles<StylesClasses>;
};

export const ProjectDetailQuery = "projects";

const TreeProject = ({ projectId, customStyles }: TreeProjectProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  const [projectData, setProjectData] = useState<any>([]);
  const [documents, setDocuments] = useState<any>();
  // const [pfdLink, setPdfLink] = useState<string>();

  const { isLoading } = useQuery(
    [ProjectDetailQuery, projectId],
    () => getProjectById(projectId),
    {
      onSuccess: (res: AxiosResponse) => {
        setProjectData(res.data);
        const groupDocTypes = _.groupBy(res?.data?.documentDetail, "type");

        setDocuments(groupDocTypes);
      },
      onError: (err: AxiosError) => {
        setProjectData([]);
      },
      refetchOnMount: true,
    },
  );

  const userId = projectData?.organizationAffiliationDetail?.userId;
  const projectType = projectData?.projectType;

  const userDetails = useAppSelector((state: any) => state.root.user);
  const role = userDetails?.data?.role;

  const { data: userData, isLoading: userDataLoading } = useQuery(
    ["userDetails", userId],
    () => getMyProfileData(userId),
    {
      onSuccess: (res: AxiosResponse) => {},
      onError: (req: AxiosError) => {},
      enabled: !!userId,
    },
  );

  const { data } = useQuery(["ioDetails", userId], () => getIOdDetails(), {
    onSuccess: (res: AxiosResponse) => {},
    onError: (req: AxiosError) => {},
    enabled: !!userId,
  });

  const [instance, updateInstance] = usePDF({});

  useEffect(() => {
    if (!!userData?.data && !!projectData && !!documents) {
      updateInstance(
        <TreePdf
          projectData={projectData}
          userData={userData?.data}
          documents={documents}
        />,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.data, projectData, documents]);

  useEffect(() => {
    const blob = instance.blob;

    if (!!blob) {
      // const dataURL = URL.createObjectURL(blob);
      // setPdfLink(dataURL);
    }
  }, [instance]);

  const treeCanopyDensityValue = Number(
    projectData?.landSpecification?.treeCanopyDensity,
  );

  const landArea = Number(projectData?.landArea);

  const occupiedArea = Number(projectData?.landSpecification?.occupiedArea);

  const { control, watch, getValues } = useForm<any>({
    mode: "onTouched",
    defaultValues: {
      landFreeFromEncumbrances: true,
      landSuitableForPlantation: true,
    },
  });
  //video
  const droneVideoFromKmlInfo = projectData?.documentDetail?.filter(
    (doc) => doc.type === "DRONE_VIDEO",
  );

  const droneVideoUrl = droneVideoFromKmlInfo?.map((doc) => doc.documentUrl);

  //kml
  const kmlUrlData = projectData?.documentDetail?.find(
    (doc) => doc.type === "LAND_KML_FILE"
  );
  const kmlUrl = kmlUrlData?.documentUrl;

  const exportQuery = (data) => {
    const extractedData = (data ?? []).map((item) => ({
      Name: item?.user?.firstName ?? "-",
      Query: item?.query ?? "-",
      created_at: dateAndTimeStamp(item?.created_at, "IST"),
    }));
    downloadSheet(extractedData);
  };
  const ioInfo = data?.data?.implementingOfficerDetails?.map((item) => {
    return {
      value: item.id,
      label: item.division,
    };
  });

  const { mutate: mutateAddIO } = useMutation(
    "AddIO",
    ({
      projectId,
      implementingOfficerId,
    }: {
      projectId: string;
      implementingOfficerId: string;
    }) => addProjectToIo(projectId, implementingOfficerId),
    {
      onSuccess: () => {},
      onError: () => {},
    },
  );

  return (
    <Box>
      {!isLoading && projectData.length !== 0 ? (
        <>
          {/* {projectData.status !== "WITHDRAWN" &&
            role !== "Approver-view-only" && (
              <Box sx={{ marginBottom: "40px", width: "60%" }}>
                <Box {...styles("heading")}>
                  Allocate Implementing Officer to Project
                </Box>
                <Box>
                  <Box>
                    <AutoComplete
                      options={ioInfo}
                      customStyles={{
                        label: defaultStyles.label,
                      }}
                      name={`implementingOfficer`}
                      control={control}
                      placeholder="List of Division"
                      label="List of Division"
                    />
                    <Button
                      text="Allocate ImplementingOfficer"
                      disabled={!watch("implementingOfficer")}
                      onClick={() => {
                        const data = getValues("implementingOfficer");
                        mutateAddIO({
                          projectId: projectId,
                          implementingOfficerId: data,
                        });
                      }}
                      customStyles={{
                        root: {
                          fontSize: "16px",
                          marginTop: "20px",
                        },
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            )} */}

          <Box {...styles("projectName")}>
            Activity Registration No: {projectData?.registrationNo}
          </Box>
          <Box {...styles("formWrapper")}>
            <Box {...styles("heading")}>
              {userData?.data?.userType === "ORGANIZATION"
                ? "Entity Details"
                : "Implementing Officer Details"}
            </Box>

            <ViewForm
              label="Username"
              value={userData?.data?.firstName}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Email"
              value={userData?.data?.email}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Phone Number"
              value={`${userData?.data?.countryCode ?? "+91"} ${
                userData?.data?.phoneNumber
              }`}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="State"
              value={userData?.data?.currentAddress?.state}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Division"
              value={userData?.data?.division}
              valueStyles={{ fontWeight: "400" }}
            />
          </Box>
          <Box {...styles("formWrapper")}>
            <Box {...styles("heading")}>
              Eco-Restoration Block Location Details
            </Box>
            <ViewForm
              label="State"
              value={projectData?.address?.stateName}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="District"
              value={projectData?.address?.districtName}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Circle"
              value={projectData?.landSpecification?.circleName}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Forest Division"
              value={projectData?.implementingOfficer?.division}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Name of site"
              value={projectData?.landSpecification?.siteName}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Revenue Block"
              value={projectData?.landSpecification?.revenueBlock}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Forest Range"
              value={projectData?.landSpecification?.range}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Compartment Number"
              value={projectData?.landSpecification?.compartmentNumber}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Beat"
              value={projectData?.landSpecification?.beat}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Survey No"
              value={projectData?.address?.khasraNo}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="TreeCanopy Density"
              value={treeCanopyDensityValue.toFixed(2)}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Total Land Area"
              value={`${landArea.toFixed(2)} ${projectData?.areaUnit}`}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Selected Area"
              value={`${occupiedArea.toFixed(2)} ${projectData?.areaUnit}`}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Slope"
              value={projectData?.landSpecification?.slope}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Terrain (Slope %)"
              value={projectData?.landSpecification?.terrain}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label=""
              value={projectData?.landSpecification?.slopeAndTerrain}
              valueStyles={{ fontWeight: "400" }}
              noDot
            />
            <ViewForm
              label="Climatic Zone"
              value={projectData?.landSpecification?.climaticZone}
              valueStyles={{ fontWeight: "400" }}
            />
            <ViewForm
              label="Accessibility with Distance"
              value={projectData?.landSpecification?.accessibility}
              valueStyles={{ fontWeight: "400" }}
            />

            <Box {...styles("imageWrapper")}>
              {projectData?.images?.map((item, idx) => {
                const imageUrl = item?.imageUrl?.fileUrl;
                if (!imageUrl) return null;
                return (
                  <Card
                    key={imageUrl || idx}
                    title={`GeoTag Image`}
                    subheader={dateAndTimeStamp(item?.updated_at, "IST")}
                    image={imageUrl}
                  />
                );
              })}
            </Box>
          </Box>
          <Box {...styles("formWrapper")}>
            <Box {...styles("heading")}>Eco-Restoration Block Details</Box>
            <ViewForm
              label="Land Type"
              value={projectData?.landType}
              valueStyles={{ fontWeight: "400" }}
            />

            <Box
              {...styles("subHeading")}
              style={{ color: "#559891ff", fontWeight: 600, marginTop: "20px" }}
            >
              Edaphic Details
            </Box>
            <Box {...styles("group")}>
              <ViewForm
                label=""
                value={projectData?.landSpecification?.edaphicDetails}
                valueStyles={{ fontWeight: "400" }}
                noDot
              />
              <ViewForm
                label="Soil Type"
                value={projectData?.landSpecification?.soilType}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Soil Depth (cm) & Texture"
                value={projectData?.landSpecification?.soilDepthAndTexture}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Soil Moisture Regime"
                value={projectData?.landSpecification?.soilMoistureRegime}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Soil pH and fertility status"
                value={projectData?.landSpecification?.soilpH}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>
            <Box
              {...styles("subHeading")}
              style={{ color: "#559891ff", fontWeight: 600, marginTop: "20px" }}
            >
              Hydrological Conditions
            </Box>
            <Box {...styles("group")}>
              <ViewForm
                label=""
                value={projectData?.landSpecification?.hydrologicalConditions}
                valueStyles={{ fontWeight: "400" }}
                noDot
              />
              <ViewForm
                label="Source Of Water"
                value={projectData?.landSpecification?.sourceOfWater}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Average Ground water level (meters)"
                value={projectData?.landSpecification?.waterSupplyLines}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Distance to Nearest Water Source (km)"
                value={
                  projectData?.landSpecification?.distanceToNearestWaterSource
                }
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Average Rainfall (milli meters)"
                value={projectData?.landSpecification?.averagRainfall}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>
            <Box {...styles("group")}>
              <ViewForm
                label="Forest Type"
                value={projectData?.landSpecification?.forestType}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Type Of Vegetation"
                value={projectData?.landSpecification?.typeOfVegetation}
                valueStyles={{ fontWeight: "400" }}
              />
              <Box {...styles("group")}>
                <ViewForm
                  label="Presence of existing trees inside Land parcel"
                  tableValue={(() => {
                    const raw = projectData?.landSpecification?.seedlingDetails;
                    try {
                      const parsed =
                        typeof raw === "string" ? JSON.parse(raw) : raw;
                      if (Array.isArray(parsed) && parsed.length > 0) {
                        return (
                          <table
                            width="500"
                            // border={1}
                            style={{ borderCollapse: "collapse" }}
                            align="center"
                          >
                            <thead>
                              <tr>
                                <th>Common Name</th>
                                <th>Botanical Name</th>
                                <th>Number of Trees</th>
                              </tr>
                            </thead>
                            <tbody>
                              {parsed.map((item) => (
                                <tr key={item.commonName}>
                                  <td style={{ textAlign: "center" }}>
                                    {item.commonName}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.botanicalName}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.numberOfSeedlings}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        );
                      }
                      return "-";
                    } catch {
                      return "-";
                    }
                  })()}
                />

                {projectData?.treeSpecificationDetail?.map((data) => {
                  return (
                    <Box
                      {...styles("group")}
                      key={data?.id ?? data?.speciesName}
                    >
                      {data?.treeType === 0 ? (
                        <>
                          <ViewForm
                            label="Existing Tree Species"
                            value={data?.speciesName}
                          />
                          {!!data?.treeSpecies &&
                            Object?.keys(data?.treeSpecies)?.map((tree) => (
                              <ViewForm
                                key={tree}
                                label="Name"
                                value={data?.treeSpecies?.[tree]}
                              />
                            ))}
                          <ViewForm
                            label="Existing Tree count"
                            value={data?.treeCount}
                          />
                        </>
                      ) : (
                        <>
                          <ViewForm
                            label="Tree Species Proposed"
                            value={data?.speciesName}
                          />
                          {!!data?.treeSpecies && (
                            <>
                              <ViewForm
                                label="Name"
                                value={data?.treeSpecies?.name}
                              />
                              <ViewForm
                                label="Species Name"
                                value={data?.treeSpecies?.speciesName}
                              />
                              <ViewForm
                                label="Species Type"
                                value={data?.treeSpecies?.speciesType}
                              />
                            </>
                          )}
                          <ViewForm
                            label="Number Of Trees Proposed"
                            value={data?.treeCount}
                          />
                        </>
                      )}
                    </Box>
                  );
                })}
              </Box>
              <ViewForm
                label="Invasive Species Details"
                value={projectData?.landSpecification?.invasiveSpeciesDetails ? "Yes" : "No"}
                valueStyles={{ fontWeight: "400" }}
              />
              {projectData?.landSpecification?.invasiveSpeciesDetails && (
                <ViewForm
                  label="Invasive Species Details"
                  value={projectData?.landSpecification?.invasiveSpeciesDetails}
                  valueStyles={{ fontWeight: "400" }}
                />
              )}
              <ViewForm
                label="Existing Fauna"
                value={projectData?.landSpecification?.existingFauna}
                valueStyles={{ fontWeight: "400" }}
              />
              {/* <ViewForm
                label="Dominant Species"
                value={projectData?.landSpecification?.dominantSpecies}
                valueStyles={{ fontWeight: "400" }}
              /> */}
            </Box>

            <Box
              {...styles("subHeading")}
              style={{ color: "#559891ff", fontWeight: 600, marginTop: "20px" }}
            >
              Socio-Environmental Context
            </Box>
            <Box {...styles("group")}>
              <ViewForm
                label="Name of the nearest village or habitation"
                value={projectData?.landSpecification?.soilCharacteristics}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Distance to nearest habitation (km)"
                value={
                  projectData?.landSpecification?.proximityToLocalCommunities
                }
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Rights And Usage"
                value={projectData?.landSpecification?.rightsAndUsage}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Community Dependency"
                value={projectData?.landSpecification?.communityDependency}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Any Existing Restrictions"
                value={projectData?.landSpecification?.anyExistingRestrictions}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>

            {projectData?.projectType === ProjectType.TREE_PLANTATION && (
              <>
                <Box {...styles("subHeading")}>Tree Specifications:</Box>

                <ViewForm
                  label="Start Date of Plantation (DD/MM/YYYY)"
                  value={getFormattedDate(projectData?.projectStartDate)}
                  valueStyles={{ fontWeight: "400" }}
                />
                <ViewForm
                  label="Activity Duration (in years)"
                  value={projectData?.projectDuration}
                  valueStyles={{ fontWeight: "400" }}
                />
              </>
            )}
          </Box>
          {projectData?.landSpecification?.description && (
            <Box {...styles("formWrapper")}>
              <Box {...styles("heading")}>Additional Information</Box>
              <ViewForm
                label="Additional Information"
                value={projectData?.landSpecification?.description}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>
          )}
          <Box {...styles("formWrapper")}>
            <Box>
              <ViewImages
                fileUrl={kmlUrl}
                label={"KML File"}
                onDownload={kmlUrl ? () => {
                  const regNo = projectData?.registrationNo;
                  const filename = regNo ? `kml_${regNo}.kml` : "kml_file.kml";
                  downloadS3File(kmlUrl, filename);
                } : undefined}
              />
            </Box>
            <Box
              sx={{
                border: "2px solid",
                borderColor: "#65a765",
                backgroundColor: "#e6ffe6",
                margin: "30px 0px",
              }}
            >
              <MapComponent kmlUrl={kmlUrl} />
            </Box>
          </Box>
          <Box {...styles("formWrapper")}>
            <Box {...styles("heading")}>GeoTag Images</Box>
            <Box {...styles("imageWrapper")}>
              {projectData?.images?.map((item, idx) => {
                return (
                  <Card
                    key={item.idx}
                    title={item?.documentName ?? `GeoTag Image`}
                    subheader={dateAndTimeStamp(item?.updated_at, "IST")}
                    image={item.imageUrl}
                  />
                );
              })}
            </Box>
          </Box>

          {/*video*/}
          <Box {...styles("formWrapper")}>
            <Box {...styles("videoFormWrapper")}>
              <Box {...styles("heading")}>Drone Video</Box>
              {!droneVideoUrl || droneVideoUrl.length === 0 ? (
                "No Drone Video Available"
              ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {droneVideoFromKmlInfo.map((doc, idx) => (
                    <Box key={doc.documentUrl || idx}>
                      <video
                        src={doc.documentUrl}
                        controls
                        width="300px"
                        height="300px"
                        style={{ borderRadius: "8px" }}
                      />
                      <Box
                        title={doc.documentName}
                        sx={{
                          maxWidth: "300px",
                          mt: 1,
                          textAlign: "center",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {doc.documentName ?? `Video ${idx + 1}`}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Box>
          <Box {...styles("formWrapper")}>
            <Box {...styles("heading")}>Forest Department Undertaking</Box>
            <Checkbox
              name="landFreeFromEncumbrances"
              control={control}
              label={
                "The land is free from all types of encumbrances and is under the management of the Union Territory/State Forest Department and suitable for eco-restoration under GCP."
              }
              rules={{
                required: true,
              }}
              disabled
            />
            <Checkbox
              name="landSuitableForPlantation"
              control={control}
              label={
                "The information filled above are the correct in best of my knowledge."
              }
              rules={{
                required: true,
              }}
              disabled
            />
          </Box>
          {projectData?.snoRemarks && (
            <Box {...styles("formWrapper")}>
              <Box {...styles("heading")}>SNO Remarks</Box>
              <ViewForm
                label="SNO Remarks"
                value={projectData?.snoRemarks}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>
          )}

          <StatusHistory
            records={projectData?.projectQuery}
            onExport={exportQuery}
          />

          {projectData?.projectQuery.length > 0 && (
            <Box {...styles("formWrapper")}>
              <Box {...styles("infoContainer")}>
                <Button
                  onClick={() => exportQuery(projectData?.projectQuery)}
                  text={""}
                  variant="outlined"
                  src="/assets/svg/export.svg"
                  customStyles={{
                    root: {
                      minWidth: "40px",
                    },
                  }}
                />
                <Box {...styles("heading")}>Project Query</Box>
              </Box>
              {projectData?.projectQuery.map((item) => (
                <Box sx={{ paddingTop: "20px" }}>
                  <ViewForm
                    label={item.user.firstName}
                    value={item.query}
                    date={dateAndTimeStamp(item.created_at, "IST")}
                    valueStyles={{ fontWeight: "400" }}
                  />
                  <Divider />
                </Box>
              ))}
            </Box>
          )}
          {projectData?.remarks && (
            <Box {...styles("formWrapper")}>
              <Box {...styles("heading")}>Remarks</Box>
              <ViewForm
                label="Admin Remarks"
                value={projectData?.remarks}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="SNO Remarks"
                value={projectData?.snoRemarks}
                valueStyles={{ fontWeight: "400" }}
              />
            </Box>
          )}
          {projectData?.comments[0]?.message && (
            <Box {...styles("formWrapper")}>
              <Box {...styles("heading")}>Withdrawal Details</Box>
              <ViewForm
                label="Withdrawal Remark"
                value={projectData?.comments[0]?.message}
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Withdrawn By"
                value={
                  [
                    projectData?.comments[0]?.user?.firstName,
                    projectData?.comments[0]?.user?.lastName,
                  ]
                    .filter(Boolean)
                    .join(" ") || "—"
                }
                valueStyles={{ fontWeight: "400" }}
              />
              <ViewForm
                label="Date"
                value={
                  projectData?.comments[0]?.created_at
                    ? dateAndTimeStamp(
                        projectData?.comments[0]?.created_at,
                        "IST"
                      )
                    : "—"
                }
                valueStyles={{ fontWeight: "400" }}
              />
              {!!projectData?.withdrawnFiles?.length && (
                <Box
                  {...styles("documentGroup", {
                    mt: "20px",
                    flexDirection: "column",
                  })}
                >
                  {projectData?.withdrawnFiles.map((item) => (
                    <ViewImages fileUrl={item.documentUrl} />
                  ))}
                </Box>
              )}
            </Box>
          )}
        </>
      ) : (
        <ProjectDetailSkeleton />
      )}
    </Box>
  );
};

export default TreeProject;
